import Footnotes from '@/utils/Footnotes';
import Transformer from '@/transformers/ProductTransformer';

const footnotes = new Footnotes();
const response = {
  subscriptionTemplateId: '11110345',
  productDescription: {
    texts: [
      {
        name: 'productName',
        text: 'Product Name',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'providerName',
        text: 'Telekom Deutschland GmbH',
        descriptionText: null,
        kind: null,
      },
      {
        name: 'productDescriptionCatalogue',
        text: 'productDescriptionCatalogue xyz',
        descriptionText: null,
        kind: null,
      },
    ],
    textLists: {},
    images: [
      {
        name: 'productLogoCatalogue',
        resourcePath: 'images/dummy_big.jpg',
        alt: 'LogoAlt',
        imageId: null,
      },
    ],
    hyperlinks: [],
    buttons: [],
    footnotes: [],
  },
  productGroup: null,
  canNotSucceed: false,
  inputType: null,
  productAvailability: null,
  price: {
    value: '10.00',
    priceDisplay: '10,00 €',
    amount: 10.0,
    currency: 'EUR',
    chargingIntervalFactor: 1,
    chargingIntervalUnit: 3,
    minimumCommitmentPeriodFactor: 24,
    minimumCommitmentPeriodUnit: 3,
    isExact: true,
    promotion: {
      value: '4.99',
      priceDisplay: '4,99 €',
      amount: 4.99,
      currency: 'EUR',
      durationFactor: 1,
      durationUnit: 3,
      promotionEnd: null,
      setupPrice: null,
    },
    setupPrice: null,
    chargingIntervalOverrideText: null,
  },
  promotionProcessing: false,
  promotionTypeOptin: false,
  bookingAllowed: true,
  belongsToFilters: ['sicherheits-pakete', 'symantec'],
};

export default Transformer.fetch(response, footnotes);
